import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sunrise, Sun, Sunset, Moon, Stars, MoonStar } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";

const PRAYERS_TR = [
    { key: "Fajr", label: "İmsak", icon: MoonStar },
    { key: "Sunrise", label: "Güneş", icon: Sunrise },
    { key: "Dhuhr", label: "Öğle", icon: Sun },
    { key: "Asr", label: "İkindi", icon: Sun },
    { key: "Maghrib", label: "Akşam", icon: Sunset },
    { key: "Isha", label: "Yatsı", icon: Stars },
];
const PRAYERS_EN = [
    { key: "Fajr", label: "Fajr", icon: MoonStar },
    { key: "Sunrise", label: "Sunrise", icon: Sunrise },
    { key: "Dhuhr", label: "Dhuhr", icon: Sun },
    { key: "Asr", label: "Asr", icon: Sun },
    { key: "Maghrib", label: "Maghrib", icon: Sunset },
    { key: "Isha", label: "Isha", icon: Stars },
];

const PrayerTimes = () => {
    const { t, lang } = useApp();
    const PRAYERS = lang === "en" ? PRAYERS_EN : PRAYERS_TR;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/prayer-times").then(({ data }) => setData(data)).catch(() => {}).finally(() => setLoading(false));
    }, []);

    if (loading || !data?.cities?.length) return null;

    return (
        <section className="py-12 border-y border-border_green bg-emerald_surface" data-testid="prayer-times-section">
            <div className="max-w-6xl mx-auto px-6 lg:px-10">
                <div className="text-center mb-6">
                    <div className="text-xs uppercase tracking-[0.3em] text-gold mb-2 flex items-center justify-center gap-2">
                        <Moon className="w-3.5 h-3.5" /> {lang === "en" ? "Sacred Cities" : "Mübarek Şehirler"}
                    </div>
                    <h2 className="font-serif text-3xl lg:text-4xl text-balance">{t("home.prayer_title")}</h2>
                    <p className="text-xs text-muted_green mt-2">
                        {lang === "en" ? "Umm al-Qura calendar (Saudi Arabia official)" : "Umm al-Qura takvimi (Suudi Arabistan resmi)"} · {lang === "en" ? "Hijri" : "Hicri"} {data.cities[0]?.hijri || "—"}
                    </p>
                </div>
                <div className="grid md:grid-cols-2 gap-px bg-border_green">
                    {data.cities.map((c, ci) => (
                        <motion.div
                            key={c.key}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: ci * 0.1 }}
                            className="bg-emerald_surface p-5"
                            data-testid={`prayer-city-${c.key}`}
                        >
                            <div className="font-serif text-2xl mb-4 text-center text-gold">
                                {lang === "en" ? (c.key === "Mecca" ? "Makkah" : c.key === "Medina" ? "Madinah" : c.label) : c.label}
                            </div>
                            <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
                                {PRAYERS.map((p) => {
                                    const Icon = p.icon;
                                    const time = c.timings?.[p.key] || "—";
                                    return (
                                        <div key={p.key} className="text-center border border-border_green bg-emerald_deep/30 py-3 px-2">
                                            <Icon className="w-3.5 h-3.5 text-gold mx-auto mb-1" />
                                            <div className="text-[10px] uppercase tracking-[0.15em] text-muted_green">{p.label}</div>
                                            <div className="font-serif text-base text-bone mt-0.5">{time}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PrayerTimes;
